import { comparisonStore } from "@/features/widgets/components/Comparison/utils/comparisonStore";
import { Product } from "@/features/widgets/components/Comparison/types/ComparisonTypes";
import WidgetHelper from "@/utils/widgetHelper.tsx";

class ComparisonHelper {

  public static WIDGET_TYPE_BUTTON_COMPARE = `button-compare`;
  public static WIDGET_TYPE_CHECKBOX_COMPARE = `checkbox-compare`;
  public static WIDGET_TYPE_COMPARISON = `comparison`;

  public static initialize = () => {
    ComparisonHelper.updateStoredProducts();
  }

  public static initializeWidget = (widget: HTMLElement, type: string) => {

    switch (type) {
      case this.WIDGET_TYPE_BUTTON_COMPARE: {
        widget.addEventListener(
          `click`,
          () => {
            const product = ComparisonHelper.getProduct(widget);
            if (product) {
              comparisonStore.toggle(product);
            }
          }
        )
        break;
      }

      case ComparisonHelper.WIDGET_TYPE_CHECKBOX_COMPARE: {
        const product = ComparisonHelper.getProduct(widget);
        const checkbox = widget as HTMLInputElement;

        comparisonStore.subscribe(() => checkbox.checked = comparisonStore.has(product.url));

        widget.addEventListener(
          `change`,
          event => {
            const target = event.target as HTMLInputElement;
            if (target.checked) {
              comparisonStore.add(product);
            } else {
              comparisonStore.remove(product.url);
            }
          }
        )
        break;
      }
    }
  }

  public static getProduct = (widget: HTMLElement) => {
    const url = widget.getAttribute(`data-ws-product-url`) || location.href;
    const name = widget.getAttribute(`data-ws-product-name`) || 'n/a';
    const image = widget.getAttribute(`data-ws-product-image`) || undefined;
    const price = widget.getAttribute(`data-ws-product-price`) as number | null || undefined;
    const category = widget.getAttribute(`data-ws-product-category`) as string | null || undefined;
    const language = WidgetHelper.getCurrentLanguage();

    const result: Product = {
      url: url,
      name: name,
      image: image,
      price: price,
      category: category,
      language: language,
    }

    return result;
  }

  public static updateStoredProducts = () => {
    const currentLanguage = WidgetHelper.getCurrentLanguage();
    const products = comparisonStore.getProducts();
    products.forEach(product => {
      if (product.language !== currentLanguage) {
        console.warn(`Product language does not match current language. Removing from comparison.`);
        comparisonStore.remove(product.url);
      }
    });
  }

}

export default ComparisonHelper;

